/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/v_hamming.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Calculates the Hamming distance between two dense vectors.
 *
 * @example
 * from colors
 * | eval similarity = v_hamming(rgb_byte_vector, [0, 127, 127])
 * | sort similarity desc, color asc
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'v_hamming',
  signatures: [
    {
      params: [
        {
          name: 'left',
          type: 'dense_vector',
          optional: false,
        },
        {
          name: 'right',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
